export default "__VITE_ASSET__DdHiwzRr__"